<template>
  <div>
    <el-tooltip
      :disabled="!item.onlyRegistered"
      class="item"
      effect="dark"
      placement="top-start"
    >
      <template slot="content">
        <span class="" v-if="item.onlySubscribed"> For Subscribers Only </span>
        <span class="" v-if="item.onlyRegistered && !item.onlySubscribed">
          For Registered Users Only
        </span>
      </template>
      <div
        class="rounded-b-lg relative shadow-xl bg-white"
        @click="handleReadMore"
      >
        <!-- Object.keys(user).length !== 0 &&
          Object.hasOwn(user, 'currentMembership') &&
          user.currentMembership.length !== 0 &&
          user.currentMembership != null &&
          Object.hasOwn(item, 'memberships') &&
          item.memberships != null &&
          Object.keys(item.memberships).length !== 0 -->
        <!-- <img
                    class="rounded-full w-6 h-6"
                    :src="$imageURL + '/' + item.memberships[0].image"
                    :style="{}"
                  /> -->
        <template>
          <span
            class="absolute top-3 left-3 z-index-999 bg-ede3fa py-1 px-3 rounded-full fsize15 text-primary"
            v-if="item.onlySubscribed"
          >
            For {{ item.memberships[0].name }} Only
          </span>
          <span
            class="absolute top-3 left-3 z-index-999 flex gap-1 bg-ede3fa py-1 px-3 rounded-full fsize15 text-primary"
            v-if="item.onlyRegistered && !item.onlySubscribed"
            ><feather-icon icon="UnlockIcon" svgClasses="w-4" />
            For Registered Users Only
          </span>
        </template>
        <!-- <div
            v-if="
              Object.keys(user).length == 0 &&
              Object.hasOwn(item, 'memberships') &&
              item.memberships != null &&
              Object.keys(item.memberships).length !== 0
            "
            class="relative"
          >
          <span class="absolute top-3 left-3 z-index-999">
            <img
                class="rounded-full w-6 h-6"
                :src="$imageURL + '/' + item.memberships[0].image"
              :style="{}"
            />
          </span>
        </div> -->

        <img
          :src="hasError ? defaultImage : image"
          alt="Blog image"
          class="rounded-t-lg h-48 w-full object-contain cursor-pointer"
          @error="hasError = true"
        />
        <div class="p-4 bg-white">
          <p
            class="text-black footertitle font-bold cursor-pointer fsize18-14px ellipsis-3 lh-28 lineclamp-1"
          >
            {{ item.title }}
          </p>
          <p class="pt-2 clr777 font-normal">
            {{
              new Date(item.date).toLocaleDateString("en-IN", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            }}
          </p>
          <div v-html="item.html" class="ellipsis-2 pt-2"></div>
          <!-- <span class="blog-tooltiptext-ui" v-if="item.onlySubscribed">
            For {{ item.memberships[0].name }} Only
          </span>
          <span
            class="blog-tooltiptext-ui"
            v-if="item.onlyRegistered && !item.onlySubscribed"
          >
            For Registered Users Only
          </span> -->
          <div v-show="readmoreblog"></div>
          <div>
            <p class="cursor-pointer" @click="readmoreblog = !readmoreblog">
              <span
                class="fsize15 sm-fsize14 text-063a88 underline"
                v-if="readmoreblog"
                >Read less</span
              >
              <span class="fsize15 sm-fsize14 text-063a88 underline" v-else
                >Read more</span
              >
            </p>
          </div>
        </div>
        <!-- <div class="md:mt-5 lg:mt-5 mt-2 flex">
        <p class="text-xs clr777 font-normal">1 Hour ago</p>
                <p class="text-xs clr777 font-normal ml-6">200 views</p>
          </div> -->
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import blogMixin from "../mixins/blogMixin";
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    Loading,
  },
  mixins: [blogMixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    category: {
      type: String,
      default: "blog",
    },
  },
  data() {
    return {
      readmoreblog: false,
      hasError: false,
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
    };
  },
  computed: {
    image() {
      return this.item.image
        ? `${this.$imageURL}/${this.item.image}`
        : this.defaultImage;
    },
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
  },
  async mounted() {
    // if (Object.keys(this.user).length !== 0) {
    //   let getUserPayload = {
    //     userId: this.user._id,
    //   };
    //   const getUser = await this.$store.dispatch(
    //     "auth/getUserByUserId",
    //     getUserPayload
    //   );
    // }
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
